import { render } from "./CustomEditor.vue?vue&type=template&id=6bcbd1ef&scoped=true"
import script from "./CustomEditor.vue?vue&type=script&lang=js"
export * from "./CustomEditor.vue?vue&type=script&lang=js"

import "./CustomEditor.vue?vue&type=style&index=0&id=6bcbd1ef&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcbd1ef"]])

export default __exports__